import PropTypes from 'prop-types';
import React from 'react';
import {
  Col,
  Grid,
  Row,
} from 'react-bootstrap';
import RangeSlider from 'react-rangeslider';
import styles from './Slider.scss';
import 'react-rangeslider/lib/index.css';

const Slider = ({
  max,
  min,
  onChange,
  step,
  value,
}) => (
  <Grid fluid className={styles.wrap}>
    <Row>
      <Col colSpan={2}>
        <RangeSlider
          labels={{}}
          max={max.value || max}
          min={min.value || min}
          onChange={onChange}
          step={step}
          tooltip={false}
          value={value}
        />
      </Col>
    </Row>
    <Row style={{
      color: '#616161',
    }}>
      <Col
        xs={6}
        style={{
          padding: 0,
        }}
      >
        <span>{min.label || min}</span>
      </Col>
      <Col
        xs={6}
        style={{
          padding: 0,
          textAlign: 'end',
        }}
      >
        <span>{max.label || max}</span>
      </Col>
    </Row>
  </Grid>
);

Slider.propTypes = {
  max: PropTypes.oneOfType([
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }),
    PropTypes.number,
  ]).isRequired,
  min: PropTypes.oneOfType([
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }),
    PropTypes.number,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  step: PropTypes.number,
  value: PropTypes.number.isRequired,
};

export default Slider;
